module.exports = __webpack_public_path__ + "static/Правила_аккредитации_СМИ.docx";